export default "__VITE_ASSET__BhR7$0H2__"